module.exports = __webpack_public_path__ + "static/media/10KM.5ad5b725.webp";